import { Icon } from "@material-ui/core";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuthenticationAction } from "Store/Authentication/AuthenticationAction";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { IApplicationState } from "Store/Store";
import styles from "./Profile.scss";

const authenticationAction = ServiceProvider.get<IAuthenticationAction>(Types.IAuthenticationAction);

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

interface IProps {
    authenticationState: IAuthenticationState;
}

interface IState {
    authenticationState?: IAuthenticationState;
}

class Profile extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {};
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.authenticationState !== prevState.authenticationState) {
            return { authenticationState: nextProps.authenticationState };
        }
        return null;
    }

    public render() {
        if (this.state.authenticationState && this.state.authenticationState.login) {
            return (
                <div id="user-block" className={styles.profile}>
                    <img src={this.state.authenticationState.login.user.pictureUrl} className={styles.avatar} />
                    <span className={styles.username}>{this.state.authenticationState.login ? this.state.authenticationState.login.user.fullName : null}</span>

                    <RouterLink to="/logout" type={RouterLinkType.default} className={styles.logout}>
                        <Icon className={styles.icon}>exit_to_app</Icon>
                    </RouterLink>
                </div>
            );
        }

        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/Components/Header/Profile/Profile.tsx